import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D92D20",
      "fill-rule": "evenodd",
      d: "M5.695 0H20l12 12v22.793C32 37.67 29.509 40 26.44 40H5.57C2.491 40 0 37.671 0 34.793V5.207C0 2.33 2.615 0 5.695 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M20.653 32v-6.55h4.413v1.142h-3.029v1.56h2.802v1.142h-2.802v1.564h3.042V32zM15.543 32v-6.55h1.384v5.408h2.808V32zM14.403 25.45V32h-1.385v-6.55zM7.75 32v-6.55h4.337v1.142H9.135v1.56h2.664v1.142H9.135V32z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-opacity": ".3",
      d: "M20.026 8.16V0L32 12h-7.983c-3.592 0-4.158-2.56-3.991-3.84"
    }, null, -1)
  ])))
}
export default { render: render }